import { jsxs as h, jsx as n } from "react/jsx-runtime";
import { useState as c } from "react";
import d from "@mui/icons-material/MoreHoriz";
import a from "styled-components";
import f from "../Box/Box.js";
import u from "../Menu/components/MenuItem.js";
import C from "../Menu/Menu.js";
const M = a(u).withConfig({
  displayName: "StyledMenuItem"
})([
  "&.menuItemRoot:hover .linkRoot,&.menuItemRoot:hover .linkRoot:hover{color:#ffffff;text-decoration:none;}"
]), k = ({ collapsedBreadcrumbs: e = void 0 }) => {
  const [t, r] = c(null), i = !!t, p = (o) => {
    r(o.currentTarget);
  };
  return /* @__PURE__ */ h(f, {
    onClick: (o) => o.stopPropagation(),
    children: [
      /* @__PURE__ */ n(d, {
        onClick: (o) => {
          p(o);
        }
      }),
      /* @__PURE__ */ n(C, {
        open: i,
        onClose: () => {
          r(null);
        },
        anchorEl: t,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: e && e.map((o) => {
          const l = !!o.props.children.length, s = l ? o.props.children[0].props.children : o.props.children.props.children;
          return /* @__PURE__ */ n(M, {
            children: l ? o.props.children.map((m) => m) : o
          }, s);
        })
      })
    ]
  });
};
k.displayName = "BreadcrumbsCollapsedMenuDropdown";
export {
  k as default
};
